import type { ProductCompany, ProductOrganizationActivityData } from "src/api/client-api/products/useGetOneProduct";
import type { ProductOrganizationActivityDataWrite } from "src/api/client-api/productOrganizationActivityData/useUpsertProductOrganizationActivityData";

export type OrganizationActivitiesFormData = Record<number, ProductOrganizationActivityData>;

export const isOwnShare = (share: ProductCompany, selectedCompanyId: number | undefined): boolean =>
    selectedCompanyId !== undefined && share.organization.id === selectedCompanyId;

export const getVisibleShares = (
    shares: ProductCompany[],
    selectedCompanyId: number | undefined,
    isProductOwner: boolean,
): ProductCompany[] => (isProductOwner ? shares : shares.filter((share) => isOwnShare(share, selectedCompanyId)));

export const getOwnActivitiesFormData = (
    shares: ProductCompany[],
    selectedCompanyId: number | undefined,
    campaignId: number | undefined,
): OrganizationActivitiesFormData =>
    shares
        .filter((share) => isOwnShare(share, selectedCompanyId))
        .reduce<OrganizationActivitiesFormData>((acc, share) => {
            const activityData = share.productOrganizationActivityDatas.find((data) => data.campaign.id === campaignId);

            return activityData === undefined ? acc : { ...acc, [share.id]: activityData };
        }, {});

export const getTotalQuantity = (activities: OrganizationActivitiesFormData): number =>
    Object.values(activities).reduce((total, activity) => total + (activity?.quantity ?? 0), 0);

export const buildActivityDataWrites = (
    activities: OrganizationActivitiesFormData,
    previousActivities: OrganizationActivitiesFormData,
    campaignId: number,
): ProductOrganizationActivityDataWrite[] =>
    Object.entries(activities)
        .filter(([productOrganizationId, activity]) => {
            const previous = previousActivities[Number(productOrganizationId)];

            return activity !== undefined && (previous === undefined || previous.quantity !== activity.quantity);
        })
        .map(([productOrganizationId, activity]) => ({
            id: activity.id,
            quantity: activity.quantity,
            productOrganization: `/api/product_organizations/${productOrganizationId}`,
            campaign: `/api/campaigns/${campaignId}`,
        }));
